import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { previewPages } from '../data/offer';
export function PreviewCarousel() {
  const [[index, direction], setState] = useState<[number, number]>([0, 0]);
  const reduceMotion = useReducedMotion();
  const total = previewPages.length;
  const go = (step: number) => setState(([current]) => [(current + step + total) % total, step]);
  // Warm up neighbours so switching feels instant, without blocking first paint.
  useEffect(() => {
    [index + 1, index - 1].forEach(i => {
      const img = new Image();
      img.src = previewPages[(i + total) % total].src;
    });
  }, [index, total]);
  const offset = reduceMotion ? 0 : 40;
  return <section className="bg-surface px-4 py-16 sm:py-24" aria-roledescription="carrusel" aria-label="Páginas del sistema" data-id="element-100" data-mp="1z11leak77tu3">
      <div className="mx-auto max-w-5xl" data-id="element-101" data-mp="1u4b2lfh0ek4z">
        <header className="text-center" data-id="element-102" data-mp="35n2ijdkudhot">
          <h2 className="font-display text-3xl font-bold text-highlight sm:text-4xl" data-id="element-103" data-mp="35odj74izq9bp">
            👀 MIRÁ POR DENTRO DEL SISTEMA
          </h2>
          <p className="mt-3 text-foreground-muted" data-id="element-104" data-mp="3ajstjmhshn3d">
            Algunas páginas del producto 👇
          </p>
        </header>
        <div className="mt-10 flex items-center justify-center gap-3 sm:gap-6" data-id="element-105" data-mp="3kcgqqicolt2m">
          <ArrowButton label="Página anterior" onClick={() => go(-1)} data-id="element-106" data-mp="3odk4mzb65f17">
            <ChevronLeftIcon className="h-6 w-6" aria-hidden="true" data-id="element-107" data-mp="3odab51qx0pqr" />
          </ArrowButton>
          <div className="relative aspect-[792/980] w-full max-w-md overflow-hidden rounded-2xl border border-highlight/20 bg-canvas shadow-2xl" data-id="element-108" data-mp="3tase8bi94aqu">
            <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-109" data-mp="75yiqo6o7kmf">
              <motion.img key={index} src={previewPages[index].src} alt={previewPages[index].alt} width="792" height="980" loading="lazy" decoding="async" draggable={false} custom={direction} initial={{
              opacity: 0,
              x: direction * offset
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: direction * -offset
            }} transition={{
              duration: 0.24,
              ease: [0.23, 1, 0.32, 1]
            }} drag="x" dragConstraints={{
              left: 0,
              right: 0
            }} dragElastic={0.2} onDragEnd={(_, info) => {
              if (info.offset.x < -60) go(1);else if (info.offset.x > 60) go(-1);
            }} className="absolute inset-0 h-full w-full cursor-grab touch-pan-y object-cover active:cursor-grabbing" data-id="element-110" data-mp="23xoxy4bmijss" />
            </AnimatePresence>
          </div>
          <ArrowButton label="Página siguiente" onClick={() => go(1)} data-id="element-111" data-mp="2oly6flt20cgg">
            <ChevronRightIcon className="h-6 w-6" aria-hidden="true" data-id="element-112" data-mp="2oo0yebdrofnt" />
          </ArrowButton>
        </div>
        <div className="mt-6 flex items-center justify-center gap-2" data-id="element-113" data-mp="2yjuj4i1n3fgo">
          {previewPages.map((page, i) => <button key={page.src} type="button" onClick={() => setState([i, i > index ? 1 : -1])} aria-label={`Ver página ${i + 1}`} aria-current={i === index} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? 'w-7 bg-highlight' : 'w-2.5 bg-foreground/25 hover:bg-foreground/50'}`} data-id="element-114" data-mp="3h850ykr72z4n" data-mpi={i} />)}
        </div>
        <p className="mt-3 text-center text-sm text-foreground-subtle" aria-live="polite" data-id="element-115" data-mp="3d58bca38m2r7">
          {index + 1} / {total}
        </p>
      </div>
    </section>;
}
interface ArrowButtonProps {
  label: string;
  onClick: () => void;
  children: React.ReactNode;
}
function ArrowButton({
  label,
  onClick,
  children
}: ArrowButtonProps) {
  return <button type="button" onClick={onClick} aria-label={label} className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-highlight/40 bg-canvas text-highlight transition-colors duration-150 ease-out hover:bg-highlight hover:text-canvas sm:h-14 sm:w-14" data-id="element-116" data-mp="2tik5j2duu9eh">
      {children}
    </button>;
}